<template>
  <button type="button" class="cart-btn bg-none" @click="cartListsOpen()">
    <ShoppingCart />
    <span
      v-if="quantity != 0"
      class="rounded-circle bg-color-red text-white p-1 font-s-12"
    >
      {{ quantity }}</span
    >
  </button>
</template>
<script>
import { cartListsOpen } from "@/libraries/functions";
import ShoppingCart from "@/parts/Front/components/Icon/ShoppingCart.vue";
export default {
  components: {
    ShoppingCart,
  },
  computed: {
    cart() {
      if (
        this.$store.getters["front/getHomeData"] != null &&
        this.$store.getters["front/getHomeData"].user.cart.cartItems != null
      ) {
        return this.$store.getters["front/getHomeData"].user.cart;
      } else {
        return null;
      }
    },
    quantity() {
      if (this.cart) {
        return this.cart.cartItems.reduce((sum, item) => {
          sum += item.quantity;
          return sum;
        }, 0);
      } else {
        return 0;
      }
    },
  },
  methods: {
    cartListsOpen() {
      cartListsOpen();
      this.$router.push(this.$route.fullPath + "#cart-modal");
    },
  },
};
</script>
